/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import Box from '@tds/core-box';
import Checkbox from '@tds/core-checkbox';
import { Accordion } from '@tds/core-expand-collapse';
import {
  subscriberDetailsContractTerm,
  contractTerm3Year
} from '../../../utils/constant';
import { getFieldValue } from '../../utils';
import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../../../contentful';
import { getPathVariables } from '../../../misc';

const RegularFeatures = ({
  formFields,
  selectedFeatures,
  setSelectedFeatures,
  showOnlyCategories
}) => {
  const [regularFeatures, setRegularFeatures] = useState();
  const locale = getPathVariables(window.location.pathname)[0];
  const config = {
    ...contentfulFormConfig,
    content_type: 'wirelessSubscribersFeatures',
    locale
  };

  useEffect(() => {
    getContentfulData(config).then(res => {
      setRegularFeatures(getData(res));
    });
  }, []);

  const valueContractTerm = getFieldValue(
    subscriberDetailsContractTerm,
    formFields
  );
  const onFeatureSelect = e => {
    const featureValue = JSON.parse(e.target.value);
    if (_.find(selectedFeatures, featureValue) === undefined) {
      setSelectedFeatures([...selectedFeatures, featureValue]);
    } else {
      const newFeatureList = selectedFeatures.filter(
        feature => feature.id !== featureValue.id
      );
      setSelectedFeatures([...newFeatureList]);
    }
  };
  const getFeatureValue = feature => {
    const featureValue = {
      id: _.get(feature, 'sys.id', uuidv4()),
      name: _.get(feature, 'fields.name', ''),
      price: _.get(feature, 'fields.price', '')
    };
    return JSON.stringify(featureValue);
  };

  return (
    <>
      {selectedFeatures && regularFeatures && (
        <Accordion tag="h3">
          {regularFeatures.categories.map(category => {
            if (
              !showOnlyCategories.length &&
              valueContractTerm !== contractTerm3Year[0] &&
              valueContractTerm !== contractTerm3Year[1]
            ) {
              return (
                <Accordion.Panel
                  id={`features-${category.sys.id}`}
                  header={_.get(category, 'fields.categoryName', '')}
                >
                  <Box between={2}>
                    {_.get(category, 'fields.features', []).map(feature => {
                        if(feature.fields.name === 'Stream+ ($25.00)'){
                          return null;
                        }
                      return (
                        <Checkbox
                          checked={
                            selectedFeatures.length > 0 &&
                            _.find(selectedFeatures, feature.fields)
                          }
                          onChange={onFeatureSelect}
                          name="feature"
                          value={getFeatureValue(feature)}
                          label={_.get(feature, 'fields.name', '')}
                        />
                      );
                    })}
                  </Box>
                </Accordion.Panel>
              );
            } else {
              if (showOnlyCategories.includes(category.fields.categoryName)) {
                return (
                  <Accordion.Panel
                    id={`features-${category.sys.id}`}
                    header={_.get(category, 'fields.categoryName', '')}
                  >
                    <Box between={2}>
                      {_.get(category, 'fields.features', []).map(feature => {
                        return (
                          <Checkbox
                            checked={
                              selectedFeatures.length > 0 &&
                              _.find(selectedFeatures, feature.fields)
                            }
                            onChange={onFeatureSelect}
                            name="feature"
                            value={getFeatureValue(feature)}
                            label={_.get(feature, 'fields.name', '')}
                          />
                        );
                      })}
                    </Box>
                  </Accordion.Panel>
                );
              }
            }
          })}
        </Accordion>
      )}
    </>
  );
};

RegularFeatures.propTypes = {
  formFields: PropTypes.arrayOf(PropTypes.any).isRequired,
  selectedFeatures: PropTypes.arrayOf(PropTypes.any).isRequired,
  setSelectedFeatures: PropTypes.func.isRequired,
  showOnlyCategories: PropTypes.array
};

export default RegularFeatures;
